<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card>
        <vx-card class="p-4 mb-3" noShadow cardBorder>
          <div class="vx-row mb-3">
            <div class="w-full vx-col md:w-1/4 sm:w-1/3">
              <label class="text-sm opacity-100 text-bold">Search</label>
              <vs-input
                type="search"
                placeholder="Search.."
                v-model="filters['search']"
                class="w-full mb-4 md:mb-0"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
              <label class="text-sm opacity-100 text-bold">Date From</label>
              <flat-pickr
                style="display: none"
                class="w-full"
                :config="{ dateFormat: 'd/m/Y' }"
                v-model="filters['from']"
                placeholder="Choose Date"
              />
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y' }"
                v-model="filters['from']"
                placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
              <label class="text-sm opacity-100 text-bold">Date To</label>
              <flat-pickr
                style="display: none"
                class="w-full"
                :config="{ dateFormat: 'd/m/Y' }"
                v-model="filters['to']"
                placeholder="Choose Date"
              />
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y' }"
                v-model="filters['to']"
                placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
              <label class="text-sm opacity-100 text-bold"
                >Account Handler</label
              >
              <v-select
                :disabled="!$can('executive-admin')"
                name="staffs"
                :closeOnSelect="false"
                :clearable="false"
                v-model="filters['account-handler-id']"
                :options="staffs"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :reduce="(option) => option.value"
                label="name"
                multiple
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold"
                >Industrial Sector</label
              >
              <v-select
                name="industry_sectors"
                :closeOnSelect="false"
                :clearable="false"
                v-model="filters['sector']"
                :options="industry_sectors"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :reduce="(option) => option.value"
                label="name"
                multiple
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Country</label>
              <v-select
                name="country"
                :closeOnSelect="false"
                :clearable="false"
                v-model="filters['country']"
                :options="countries"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :reduce="(option) => option.name"
                label="name"
                multiple
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Customer</label>
              <v-select  :clearable="true" placeholder="" :reduce="option => option.value"  v-model="filters['customer-ids']"
                         :options="customers" label="name"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Type(s)</label>
              <v-select  :clearable="true" placeholder="" :reduce="option => option.name"  v-model="filters['type']"
                         :options="vam_types" label="name" multiple
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                          color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
            </div>
          </div>
        </vx-card>

        <div class="vx-row" id="vam-table">
          <div class="vx-col w-full">
            <vx-card title="Value added moments (VAM)">
              <template slot="actions">
                <div class="flex">
                  <ExcelDownload name="customer-vam-sheet" class="" :filters="filters" :data_obj="activityList"/>
                </div>
              </template>
              <div slot="no-body" class="mt-4">
                <vs-table stripe sort class="mt-8" :data="activityList">
                <template slot="thead">
                  <vs-th width="10%">CODE</vs-th>
                  <vs-th width="10%">COST TO COMPANY</vs-th>
                  <vs-th width="10%">CUSTOMER</vs-th>
                  <vs-th width="10%">DATE</vs-th>
                  <vs-th width="20%">TYPE(S)</vs-th>
                  <!-- <vs-th width="10%">REASON CODE</vs-th> -->
                  <vs-th width="5%">VALUE TO CUSTOMER</vs-th>
                  <vs-th width="10%">LINKED SO</vs-th>
                  <vs-th width="20%">DESCRIPTION</vs-th>
                  <vs-th width="5%">ACTION</vs-th>
                  <!-- <vs-th width="10%">ACTION</vs-th> -->
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    class="cursor-pointer"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td>
                      {{ data[indextr].code }}
                    </vs-td>
                    <vs-td>
                      {{ data[indextr].cost_to_company !== '' ? data[indextr].cost_to_company : 'N/A' }}
                    </vs-td>
                    <vs-td>
                      {{ data[indextr].customer.company_name }}
                    </vs-td>
                    <vs-td>
                      {{ data[indextr].date }}
                    </vs-td>
                    <vs-td>
                      {{ data[indextr].type.map(type => type).join(", ") }}
                    </vs-td>
                    <!-- <vs-td>
                      {{ data[indextr].reason || '-' }}
                    </vs-td> -->
                    <vs-td>
                      {{ data[indextr].value_to_customer !== '' ? data[indextr].value_to_customer : 'N/A'}}
                    </vs-td>
                    <vs-td>
                      <span v-if="data[indextr].product_orders.length > 0">
                        <span v-for="(order, index) in data[indextr].product_orders" :key="index">
                          <span @click.stop="onClickOpenSo(order.id)" class="text-primary cursor-pointer">{{ order.product_order_code }}</span>
                        </span>
                      </span>
                      <span v-else>
                        N/A
                      </span>
                    </vs-td>
                    <vs-td>
                      {{ data[indextr].description || 'N/A' }}
                    </vs-td>
                    <vs-td>
                      <div class="justify-start vx-row">
                        <vx-tooltip text="View/Update" position="left">
                          <vs-button
                            @click.stop="onClickUpdate(data[indextr])"
                            class="ml-3"
                            size="small"
                            color="warning"
                            type="border"
                            icon-pack="feather"
                            icon="icon-edit-2"
                          ></vs-button>
                        </vx-tooltip>
                        <vx-tooltip text="Delete" position="left">
                          <vs-button @click.stop="openConfirmDeleteVam(data[indextr].id)" class="ml-3" size="small" color="danger"
                            type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                        </vx-tooltip>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vx-pagination
                v-on:changeMaxItems="changePage"
                :size-array="meta.total ? meta.total : 20"
                :max-items="perPage"
                description-body="Rows per page"
                description-connector="of"
                description-title="Records"
                description
                :description-items="descriptionItems"
                :total="meta.last_page ? meta.last_page : 0"
                v-model="page"
                class="p-5"
              >
              </vx-pagination>
              </div>
            </vx-card>
          </div>
        </div>
      </vx-card>
    </div>
    <create-customer-crm-snapshot-pop-up ref="createCustomerCrmSnapshotPopUp" :customer_id="customerId" />
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import { defaultPagination, perPageList } from "@/constants/config";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import ErrorMessages from "@/mixins/ErrorMessages";
import { mapActions, mapGetters } from "vuex";
import CreateCustomerCrmSnapshotPopUp from '@/components/popups/crm/customer/snapshots/CreateCustomerCrmSnapshotPopUp.vue'
import ExcelDownload from "@/components/excel/ExcelDownload.vue";

import Filter from "@/mixins/filter";
const CrmRepository = RepositoryFactory.get("crm");

export default {
  name: "ValueAddedMomentsAggregatedActivity",
  data() {
    return {
      activityList: [],
      page: 1,
      total: 0,
      meta: {},
      sort: "",
      perPage: defaultPagination,
      descriptionItems: perPageList,
      filters: {
        customer_id: null,
      },
      vam_types: []
    };
  },
  components: {
    flatPickr,
    "v-select": vSelect,
    CreateCustomerCrmSnapshotPopUp,
    ExcelDownload
  },
  async mounted() {
    await this.fetchVamActivityList();
    await this.fetchStaffs();
    await this.fetchIndustrySections();
    await this.fetchCountries();
    await this.fetchCustomers();
    await this.fetchSnapVamTypes()
  },
  computed: {
    ...mapGetters(["staffs", "industry_sectors", "countries", "customers"]),
  },
  mixins: [Filter, ErrorMessages],
  watch: {
    page() {
      this.fetchVamActivityList();
    },
    perPage() {
      this.fetchVamActivityList();
    },
  },
  methods: {
    ...mapActions(["fetchStaffs", "fetchIndustrySections", "fetchCountries", "fetchCustomers"]),
    async refreshData() {
        await this.fetchVamActivityList()
    },
    async fetchVamActivityList() {
      try {
        await this.$vs.loading({
          container: "#vam-table",
          scale: 0.45,
        });
        const { data } = await CrmRepository.getListOfCustomerSnapshot(
          "",
          this.page,
          this.filterQuery,
          this.perPage
        );
        this.activityList = data.data;
        this.meta = data.meta;
      } catch (e) {
      } finally {
        this.$vs.loading.close("#vam-table > .con-vs-loading");
      }
    },
    async onClickUpdate(item){
        await this.$refs.createCustomerCrmSnapshotPopUp.openPopup(item.id)
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchVamActivityList();
    },
    filterQueryUpdate() {
      this.page = 1;
      this.fetchVamActivityList();
    },
    changePage(index) {
      this.page = 1;
      this.perPage = this.descriptionItems[index];
    },
    onClickOpenSo(id) {
      const route = this.$router.resolve({ path: `/pages/product-orders/${id}` });
      window.open(route.href, '_blank');
    },
    openConfirmDeleteVam(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        acceptText: 'Confirm',
        text: 'Are you sure you want to delete this ?',
        accept: this.onClickDeleteVam,
        parameters: [id]
      })
    },
    async onClickDeleteVam(params) {
      try {
        await CrmRepository.deleteCustomerSnapshot(params[0])
        await this.refreshData()
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async fetchSnapVamTypes() {
      try {
        const { data } = (await CrmRepository.getListVamType()).data
        this.vam_types = data
      } catch (error) {

      }
    },
  },
};
</script>
